import { Checkout, CheckoutConfig } from 'models/checkout';

export class DadosPagamento extends Checkout {
  valorTotal: number;
  valorParcela: number;
  configuracao: CheckoutConfig;

  constructor(args) {
    super(args);
    Object.assign(this, args);
  }
}
